(function (angular, ToyotaForms) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('formsKeepMeInformed', ['$filter', 'API', function ($filter, API) {
            formsKeepMeInformedController.$inject = ['$scope'];
            function formsKeepMeInformedController($scope) {
                $scope.init = function () {

                    $scope.fields = {
                        firstname: '',
                        lastname: '',
                        postcode: '',
                        phone: '',
                        email: '',
                        agreement: false,
                        buyingTimeline: '',
                        formName: '',
                        campaignCode: ''
                    };

                    $scope.fieldProps = {
                        phoneMaxLength: 10,
                        phonePattern: /^[0-9]{10}$/,
                        emailPattern: ToyotaForms.RegularExpressions.EmailPattern
                    };

                    $scope.form = {
                        submitting: false,
                        completed: false,
                        success: false
                    };

                    $scope.vehicleModelList = [];

                };

                $scope.init();

                $scope.getData = function () {

                    var subscribe;
                    if ($('#terms-checkbox').length) {
                        subscribe = $scope.fields.agreement;
                    }
                    else {
                        subscribe = true;
                    }
                    return {
                        FirstName: $scope.fields.firstname,
                        LastName: $scope.fields.lastname,
                        Email: $scope.fields.email,
                        Phone: $scope.fields.phone,
                        CarSelectionOne: $scope.fields.carSelectionOne,
                        CarSelectionTwo: $scope.vehicleModelList.length > 1 ? $scope.fields[$scope.vehicleModelList[1]] : '',
                        CarSelectionThree: $scope.vehicleModelList.length > 2 ? $scope.fields[$scope.vehicleModelList[2]] : '',
                        BuyingTimeLine: $scope.fields.buyingTimeline,
                        Subscribe: subscribe,
                        PhoneType: 'Not Specified',
                        FormName: $scope.fields.formName,
                        CampaignCode: $scope.fields.campaignCode
                    };
                };

                $scope.validateOtherVehicles = function (thisVehicle) {
                    switch (thisVehicle) {
                        case $scope.vehicleModelList[0]:
                            try {
                                $scope.wfm[$scope.vehicleModelList[1]].$validate();
                                $scope.wfm[$scope.vehicleModelList[2]].$validate();
                            } catch (e) {
                                // no errors if the fields don't exist
                            }

                            break;

                        case $scope.vehicleModelList[1]:
                            try {
                                $scope.wfm[$scope.vehicleModelList[0]].$validate();
                                $scope.wfm[$scope.vehicleModelList[2]].$validate();
                            } catch (e) {
                                // no errors if the fields don't exist
                            }

                            break;

                        case $scope.vehicleModelList[2]:
                            try {
                                $scope.wfm[$scope.vehicleModelList[0]].$validate();
                                $scope.wfm[$scope.vehicleModelList[1]].$validate();
                            } catch (e) {
                                // no errors if the fields don't exist
                            }

                            break;
                    }
                };

                $scope.vehicleInvalid = function (fieldId) {
                    // only validate while the user is filling the form
                    if (!$scope.wfm[fieldId].$touched && !$scope.wfm.$submitted) {
                        return false;
                    }

                    return !$scope.wfm[fieldId].$valid;
                };

                $scope.vehicleValid = function (fieldId) {
                    // only validate while the user is filling the form
                    if (!$scope.wfm[fieldId].$touched) {
                        return false;
                    }

                    return $scope.wfm[fieldId].$valid;
                };

                $scope.submit = function () {
                    $scope.form.submitting = true;

                    var url = $filter('formatArgs')(ToyotaForms.API.FormSubmission.KeepMeInformed);
                    var data = $scope.getData();

                    API.post(url, data)
                        .then(function (req) {
                            $scope.form.submitting = false;

                            if (req.data.isSuccessful) {
                                $scope.form.completed = true;
                                $scope.form.success = true;
                            } else {
                                $scope.form.completed = true;
                                $scope.form.success = false;
                            }

                            if ($scope.form.completed && $scope.form.success) {
                                $scope.$broadcast('form-success');
                            } else {
                                $scope.$broadcast('form-failure');
                            }
                        }, function () {
                            $scope.form.completed = true;
                            $scope.form.success = false;
                            $scope.$broadcast('form-server-error');
                        });
                };
            }

            return {
                scope: true,
                restrict: 'A',
                controller: formsKeepMeInformedController,
                controllerAs: 'fc',
                bindToController: true,
                link: function (scope, element) {
                    var destObj = {};

                    angular.forEach(element.find('ui-select'), function (ele) {
                        var id = angular.element(ele).attr('id');
                        scope.vehicleModelList.push(id);
                        destObj[id] = '';
                    });

                    //Extending select field models as these are dynamic(sitecore editable)
                    angular.extend(destObj, scope.fields);
                    scope.fields = destObj;

                    $('#firstname').focus();
                }
            };
        }]);
})(window.angular, window.ToyotaForms);
